var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classSelectItem",on:{"click":function($event){return _vm.selectClass()}}},[_c('div',{class:[_vm.isSelected ? 'equipmentTextActive' : 'equipmentText']},[_c('h4',[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }